<template>

  <div class="collection">

    <div class="collectionList flex flex-wrap gap-4px justify-between">
      <div class="sorting   border-box mb-[10px] cursor-pointer" v-for="(item, index) in collectionList" :key="index">
        <div
          class="list flex flex-wrap gap-10px w-[132px] justify-between p-10px bg-[#f8f8fb] rounded-md pb-[0px] hover:bg-[#e8e8ed]"
          style="border-radius:8px;" @click="handleMoreClick(item)">
          <div class="img w-[50px] h-[50px] rounded-md overflow-hidden mb-[10px]"
            v-for="(items, indexs) in item.materials.slice(0, 4)" :key="indexs">
            <img :src="items.preview_url_small" alt="">
          </div>
        </div>
        <div class="name   w-[132px] flex justify-between mt-[10px]">
          <div class="text-ellipsis whitespace-nowrap overflow-hidden w-[102px] text-[12px]">{{ item.name }}</div>
          <div class="text-[12px] text-[#808080]">{{ item.materials_count }}张</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { getCollectionPages } from '@/api/affairs'

const props = defineProps({
  showNum: {
    type: Number,
    default: 4
  },
  searchkwords: {
    type: String,
    default: ''
  }
})


const collectionList = ref([])
const emit = defineEmits<{
  selectMore: {},
  num: {}
}>()
const handleMoreClick = (item) => {
  console.log(item)
  emit('selectMore', item)
}
onMounted(() => {
  getCollectionPages({ page: 1, size: props.showNum ? props.showNum : 10, name: props.searchkwords }).then(res => {
    if (res.data?.data?.items) {
      collectionList.value = res.data?.data?.items
      emit('num', collectionList.value.length)
    }
  })
})


</script>
<style lang="scss"></style>
